import {
    IProfileChild,
    IProfileOptionsResponse,
    IUserProfileUpdateRequest,
} from '@kcftech/prometheustypescriptapiclient';
import { CollapsiblePane } from 'components/expandable_pane/CollapsiblePane';
import { PaneSection } from 'components/expandable_pane/PaneSection';
import { ProfileSettingDropdownInlineEditor } from 'components/inline_edit/ProfileSettingDropdownInlineEditor';
import { useState } from 'react';

export type VibrationOptionsPaneProps = Readonly<{
    options: IProfileOptionsResponse;
    profile: IProfileChild;
    className?: string;
    onChange: (updates: Partial<IUserProfileUpdateRequest>) => void;
}>;

export function VibrationOptionsPane({
    options: { VelocityUnits, AccelerationUnits },
    profile,
    className,
    onChange,
}: VibrationOptionsPaneProps) {
    const [expanded, setExpanded] = useState(false);

    return (
        <CollapsiblePane
            expanded={expanded}
            onChange={setExpanded}
            className={className}
            title="Vibration Units"
        >
            <PaneSection label="Velocity Units">
                <ProfileSettingDropdownInlineEditor
                    options={VelocityUnits}
                    value={
                        VelocityUnits.find(
                            (option) => option.Value === profile.VelocityUnits
                        ) ?? VelocityUnits[0]
                    }
                    onConfirm={(value) => onChange({ VelocityUnits: value?.Value })}
                />
            </PaneSection>
            <PaneSection label="Acceleration Units">
                <ProfileSettingDropdownInlineEditor
                    options={AccelerationUnits}
                    value={
                        AccelerationUnits.find(
                            (option) => option.Value === profile.AccelerationUnits
                        ) ?? AccelerationUnits[0]
                    }
                    onConfirm={(value) => onChange({ AccelerationUnits: value?.Value })}
                />
            </PaneSection>
        </CollapsiblePane>
    );
}
